import { formatearFechaCompleta, formatearPrecio } from '../../../../utils/utils';
import React, { useEffect, useState, useMemo } from 'react';
import { 
  Copy, 
  Video,
  KeyRound,
  Check,
  UserCheck, 
  FileCheck, 
  Bell, 
  DollarSign, 
  RotateCcw, 
  Eye, 
  AlertTriangle,
  FileText,
  AlertCircle,
  Settings,
  CheckCircle,
  XCircle,
  Send,
} from 'lucide-react';
import DescripcionActividadSolicitud from '../../solicitudes/components/infoSolicitudes';
import FileUploader from '../../../../components/FileUploader';
import FileViewer from '../../../../components/FileViewer';
import ModuloEntregas from '../ModuloEntregas';
import ModuloTesis from '../ModuloTesis';
import PreguntasComponent from '../../solicitudes/Modulos/Preguntas';
import FileViewerBien from '../../../../components/FileViewerBien';
import ModuloRevision from '../ModuloRevision';

const TutorViewServicio = ({
  servicio, 
  visibleTabs, 
  handleTabChange,
  activeTab,
  solicitud,
  cliente,
  formData,
  setFormData,
  nombreEmpresaReal,
  handleFormularioEntrega,
  entregarTrabajo,
  usuario,
  handleEnviarPregunta,
  handleSaveTesis,
}) => {

  //copiado
  const [copied, setCopied] = useState(false);
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            // Resetea el ícono de 'copiado' después de 2 segundos
            setTimeout(() => setCopied(false), 2000);
        }).catch(err => {
            console.error('Error al copiar texto: ', err);
        });
  };
  const [confirmado, setConfirmado] = useState(false);

  if (usuario.nombrewhatsapp !== servicio.tutor) {
    return (
      <div className="flex flex-col items-center justify-center p-12 bg-white rounded-3xl shadow-xl border border-red-100">
        <div className="bg-red-100 p-4 rounded-full mb-4">
          <AlertTriangle size={48} className="text-red-600" />
        </div>
        <h2 className="text-2xl font-bold text-gray-800 mb-2">Acceso Denegado</h2>
        <p className="text-gray-600 text-center max-w-md">
          Lo sentimos, no tienes permisos para visualizar este servicio. 
        </p>
        <button 
          onClick={() => window.history.back()}
          className="mt-6 px-6 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-700 transition-colors"
        >
          Volver atrás
        </button>
      </div>
    );
  }

  // Función para manejar el cambio del checkbox
  const handleCheckboxChange = (e) => {
    setConfirmado(e.target.checked);
  };

  //tutor view
  const TutorView = () =>{
      return (
        <div>
        {/* Info de entrega - Cards con iconos */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-6 bg-blue-50">
          <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
            <div className="flex items-center gap-3 mb-1">
              <div className="bg-blue-100 p-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <span className="text-gray-500">Fecha límite</span>
            </div>
            <p className="font-medium text-gray-800 ml-10">{formatearFechaCompleta(servicio.fechaentrega)}</p>
          </div>
          
          <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
            <div className="flex items-center gap-3 mb-1">
              <div className="bg-green-100 p-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <span className="text-gray-500">Precio cobrado</span>
            </div>
            <p className="font-medium text-gray-800 ml-10">{formatearPrecio(servicio?.preciotutor)}</p>
          </div>
          
          <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100">
            <div className="flex items-center gap-3 mb-1">
              <div className="bg-purple-100 p-2 rounded-full">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                </svg>
              </div>
              <span className="text-gray-500">Código servicio</span>
            </div>
            <p className="font-medium text-gray-800 ml-10">{servicio?.codigo}</p>
          </div>

          {servicio?.identificadorcodigo == "A" && (
            <div className="bg-white p-4 rounded-lg shadow-sm border-border-gray-100">
              <div className="flex items-center gap-3 mb-1">
                <div className="bg-orange-100 p-2 rounded-full">
                  {/* Icono de Lucide React */}
                  <Video className="h-5 w-5 text-orange-600" strokeWidth={2} />
                </div>
                <span className="text-gray-500">Enlace de la reunión</span>
              </div>
              <a
                href={servicio?.ObjetoAsesoria?.hangoutLink}
                target="_blank"
                rel="noopener noreferrer"
                className="font-medium text-blue-600 hover:underline ml-10"
              >
                Unirse a la reunión
              </a>
            </div>
          )}

        </div>

        {/* Credenciales de plataforma */}
        {solicitud.proPlataforma?.manejoPlataforma && (
            <div className="mt-6">
                {/* === TARJETA ÚNICA Y COMPACTA === */}
                <div className="bg-white border border-gray-200 rounded-lg shadow-md overflow-hidden font-sans">
                    
                    {/* ENCABEZADO ROJO (Más pequeño) */}
                    <div className="bg-red-600 p-2 flex items-center justify-center text-white space-x-2">
                        <AlertCircle size={18} />
                        <h3 className="font-bold text-base uppercase tracking-normal">
                            Manejo de Plataforma Especial
                        </h3>
                    </div>

                    {/* CUERPO PRINCIPAL */}
                    <div className="p-4">
                        {/* Información resumida */}
                        <p className="text-sm text-gray-700 mb-3">
                            Este servicio requiere gestión completa en plataforma (UNAD). Se debe participar en: <strong>Foros, trabajos colaborativos, videos, etc.</strong>
                        </p>
                        <ul className="text-xs font-semibold text-red-700 space-y-1">
                            <li className="flex items-center"><span className="mr-2">⚠️</span><span>Es fundamental evitar el plagio y el uso excesivo de IA.</span></li>
                        </ul>

                        {/* === SECCIÓN DE CREDENCIALES (CONDICIONAL Y COMPACTA) === */}
                        {cliente?.clienteEspecialPlataformaUNAD && (
                            <div className="mt-4 pt-4 border-t border-gray-200">
                                <div className="flex items-center text-emerald-600 mb-2">
                                    <KeyRound size={16} className="mr-1.5" />
                                    <h4 className="font-bold text-sm">CREDENCIALES DE ACCESO</h4>
                                </div>
                                
                                {/* Grid para mostrar credenciales en columnas */}
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-3 text-sm">
                                    {/* Plataforma */}
                                    <div className="bg-gray-50 p-2 rounded-md border">
                                        <p className="text-xs font-semibold text-gray-500">Plataforma</p>
                                        <p className="font-medium text-gray-800 truncate" title={cliente?.infoPlataforma.plataforma}>
                                            {cliente?.infoPlataforma.plataforma}
                                        </p>
                                    </div>
                                    
                                    {/* Usuario */}
                                    <div className="bg-gray-50 p-2 rounded-md border">
                                        <p className="text-xs font-semibold text-gray-500">Usuario</p>
                                        <p className="font-medium text-gray-800 truncate" title={cliente?.infoPlataforma.usuario}>
                                            {cliente?.infoPlataforma.usuario}
                                        </p>
                                    </div>

                                    {/* Contraseña */}
                                    <div className="bg-gray-50 p-2 rounded-md border">
                                        <p className="text-xs font-semibold text-gray-500">Contraseña</p>
                                        <div className="flex items-center justify-between">
                                            <span className="font-mono text-gray-800 select-all">{cliente?.infoPlataforma.contrasena}</span>
                                            <button 
                                                onClick={() => handleCopy(cliente.infoPlataforma.contrasena)}
                                                className="p-1 rounded-md hover:bg-gray-200 transition-colors"
                                                title="Copiar contraseña"
                                            >
                                                {copied ? <Check className="text-green-500" size={16} /> : <Copy className="text-gray-500" size={16} />}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
         )}

        <div className="p-6">

          {/* Descripción actividad - Pestañas mejoradas */}
          <div className="mb-8">
            <DescripcionActividadSolicitud 
                  solicitud={solicitud}
                  initialTab="descripcion"
                />
          </div>

          
         {/* Subir archivos - Diseño mejorado */}
          {!servicio.getTrabajoEntregado() && (
            <div className="mb-8">
              <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                </svg>
                Subir archivos
              </h3>
              
              <div className="bg-gray-50 border-2 border-dashed border-gray-300 rounded-lg p-8 text-center mb-4 hover:bg-gray-100 transition-colors">
                <FileUploader
                  formData={formData}
                  setFormData={setFormData}
                  fieldName="trabajos"
                  allowedTypes={[]}
                  maxSize={100 * 1024 * 1024}
                  label="trabajo"
                  multiple={true}
                />
                
                <div className="mt-3 text-sm text-gray-500">

                </div>
              </div>
            </div>
          )}

           {/* Vista de archivos */} 
          <FileViewer 
            IdCarpeta={servicio.codigo}
            nombreEmpresa={nombreEmpresaReal}
            onDeleteFile={(files) => {
            }}/>

          {!servicio.getTrabajoEntregado()  && (servicio.identificadorcodigo !== "P" && servicio.identificadorcodigo != "Q" )? (
            <>
            {/* Comentarios - Diseño mejorado */}
            <div className="mb-8">
              <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z" />
                </svg>
                Comentarios de entrega
              </h3>
              
              <textarea 
                className="w-full p-4 border border-gray-300 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-shadow" 
                rows="4" 
                name="comentarioEntrega"
                value={formData.comentarioEntrega}
                onChange={handleFormularioEntrega}
                placeholder="Añade cualquier comentario o nota adicional para el cliente..."
              ></textarea>

            </div>
            
            {/* Confirmación - Diseño mejorado */}
            <div className="bg-amber-50 p-5 rounded-xl border border-amber-200 mb-8 shadow-sm">
              <div className="flex items-start mb-4">
                <input 
                  type="checkbox" 
                  checked={confirmado}
                  onChange={handleCheckboxChange}
                  id="confirm" 
                  className="mt-1 mr-3 h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500" 
                />
                <label htmlFor="confirm" className="text-gray-700 font-medium">
                  Confirmo que este trabajo es 100% original y cumple con <span className="uppercase font-bold text-blue-800">TODOS</span> los requisitos y criterios SOLICITADOS en la descripción de la actividad.
                </label>
              </div>
              
              <div className="bg-white border-l-4 border-red-500 p-4 rounded-r-md mb-4">
                <p className="font-semibold text-red-700 mb-2 flex items-center gap-2">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                  IMPORTANTE:
                </p>
                <ul className="text-sm text-gray-700 ml-5 list-disc space-y-2">
                  <li><span className="font-semibold">Revise detenidamente</span> la información y descripción de la solicitud antes de entregar.</li>
                  <li>Es <span className="font-semibold">OBLIGATORIO</span> adjuntar el reporte de plagio e IA junto con la entrega final (solo si lo requiere, los trabajos que requieren esto son cualquier trabajo que no se haga a mano).</li>
                  <li>No se permiten trabajos con más del <span className="font-semibold">15% de similitud</span> en el reporte de plagio.</li>
                  <li>No se permiten trabajos con más del <span className="font-semibold">20% de contenido generado por IA</span>.</li>
                </ul>
              </div>
              
              <p className="text-sm text-gray-600 italic">
                El incumplimiento de estos criterios resultará en el rechazo del trabajo y posibles penalizaciones.
                Todos los trabajos serán verificados mediante Turnitin.
              </p>
            </div>
            
            {/* Botones - Diseño mejorado */}
            <div className="flex flex-col sm:flex-row justify-end gap-4">
            <button 
              onClick={entregarTrabajo}
              disabled={!confirmado}
              className={`px-6 py-3 rounded-lg transition-colors flex items-center justify-center gap-2 font-medium shadow-md ${
                  confirmado 
                    ? 'bg-green-600 text-white hover:bg-green-700 cursor-pointer' 
                    : 'bg-gray-400 text-gray-600 cursor-not-allowed'
                }`}
              >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              Finalizar y entregar
            </button>
            </div>
            </>
          ) : (
            <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6 mb-8 shadow-sm">
              <div className="flex items-center justify-center mb-4">
                <div className="h-16 w-16 bg-green-100 rounded-full flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              </div>
              <h3 className="text-xl font-bold text-center text-green-700 mb-2">
                ¡Trabajo entregado con éxito!
              </h3>
              <p className="text-center text-green-600 mb-4">
                Este trabajo fue entregado el {formatearFechaCompleta(servicio.entregatutorFecha)}
              </p>
            </div>
          )}

        </div>
        
      </div>
      );
  }

  return (
    <div className="bg-white rounded-3xl shadow-xl overflow-hidden p-8">
                {/* Navegación de tabs mejorada */}
                <div className="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200">
                  <nav className="flex space-x-1 overflow-x-auto scrollbar-hide p-2">
                    {visibleTabs.map((tab) => (
                      <button
                        key={tab.id}
                        onClick={() => handleTabChange(tab.id)}
                        className={`group relative py-4 px-6 font-medium text-sm flex items-center gap-3 whitespace-nowrap flex-shrink-0 transition-all duration-300 rounded-2xl ${
                          activeTab === tab.id
                            ? 'bg-white text-blue-700 shadow-lg transform -translate-y-0.5'
                            : 'text-gray-600 hover:text-gray-800 hover:bg-white hover:bg-opacity-60'
                        }`}
                      >
                        {/* Indicador activo */}
                        {activeTab === tab.id && (
                          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-8 h-1 bg-blue-500 rounded-full"></div>
                        )}
                        
                        <div className={`p-2 rounded-lg transition-colors ${
                          activeTab === tab.id ? 'bg-blue-100' : 'bg-gray-200 group-hover:bg-gray-300'
                        }`}>
                          <tab.icon size={16} className={activeTab === tab.id ? 'text-blue-600' : 'text-gray-500'} />
                        </div>
                        
                        <div className="flex flex-col items-start">
                          <span className="hidden sm:inline font-semibold">{tab.label}</span>
                          <span className="sm:hidden font-semibold">
                            {tab.id === 'general' ? 'General' : 
                            tab.id === 'cotizaciones' ? 'Cotiz.' : 
                            tab.id === 'notificaciones' ? 'Notif.' : 'Vistas'}
                          </span>
                          
                          {tab.count !== undefined && tab.count > 0 && (
                            <span className={`mt-1 px-2 py-0.5 text-xs rounded-full font-bold transition-colors ${
                              tab.id === 'cotizaciones' 
                                ? 'bg-green-500 text-white'
                                : tab.id === 'vistas'
                                ? 'bg-blue-500 text-white'
                                : tab.id === 'notificaciones'
                                ? 'bg-orange-500 text-white'
                                : 'bg-gray-500 text-white'
                            }`}>
                              {tab.count}
                            </span>
                          )}
                        </div>
                      </button>
                    ))}
                  </nav>
                </div>

                 {/* Contenido de las tabs con padding mejorado */}
                <div className="p-8">
                  {activeTab === 'general' && TutorView()}
                  {activeTab === 'preguntas' && 
                    <PreguntasComponent 
                        preguntas={servicio.preguntas}
                        usuarioActual={usuario}
                        isAdmin={false}
                        onEnviarPregunta={handleEnviarPregunta}
                        onResponderPregunta={handleEnviarPregunta}
                        bloqueoPreguntas={servicio.getTrabajoEntregado()}
                      />
                  }
                  {activeTab === 'tesis' && <ModuloTesis servicio={servicio} onGuardarCalendario={handleSaveTesis} solicitud={solicitud}/>}
                  {activeTab === 'entregas' && <ModuloEntregas servicio={servicio} isAdmin={false}/>}
                  {activeTab === 'revision' && 
                    <ModuloRevision 
                      servicio={servicio} 
                      isAdmin={false}
                    />}
                </div>

    </div>
  );


}

export default TutorViewServicio
